import {Component, OnInit} from '@angular/core';
import {PusherService} from "../services/pusher.service";

@Component({
  selector: 'app-push',
  templateUrl: './push.component.html',
  styleUrls: ['./push.component.scss'],
  providers: [PusherService]
})
export class PushComponent implements OnInit {

  model = {
    instanceId: '',
    secret: '',
    installationId: '',
    messageBody: ''
  };

  constructor(private _pusherService: PusherService) {
  }

  ngOnInit() {
  }

  onSubmit() {
    console.log(`[PushComponent.onSubmit]: this.model`, this.model);
    this._pusherService.send(
      this.model.instanceId,
      this.model.secret,
      this.model.installationId,
      this.model.messageBody
    ).subscribe((result: any) => {
      console.log(`[PushComponent.onSubmit]: result`, result);
    }, error => {
      console.error(error);
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/push/push.component.ts